import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css'
import './language/i18n'
import { isNotLoginLogin } from './utils/session'
import LoginRoute from './components/route/LoginRoute'
import Login from './components/pages/login/Login'
import Dashboard from './components/pages/dasboard/Dashboard'
import PrivateRoute from './components/route/PrivateRoute'
import FormMyAccount from './components/pages/users/FormMyAccount'
import Users from './components/pages/users/Users'
import FormUsers from './components/pages/users/FormUsers'
import FormCompany from './components/pages/company/FormCompany'
import Share from './components/pages/share/Share'
import Rent from './components/pages/rent/Rent'
import FormRent from './components/pages/rent/FormRent'
import Bill from './components/pages/bill/Bill'
import FormCompanyUserDisabledays from './components/pages/users/FormCompanyUserDisabledays'
import FormCompanyUserTimeTable from './components/pages/users/FormCompanyUserTimeTable'
import Timetable from './components/pages/timetable/TimeTable'
import FormTimeTable from './components/pages/timetable/FormTimeTable'
import Disabledays from './components/pages/disabledays/Disabledays'
import FormDisabledays from './components/pages/disabledays/FormDisabledays'
import FormChangePass from './components/pages/users/FormChangePass'
import Recoverypass from './components/pages/login/Recoverypass'
import RecoverypassOk from './components/pages/login/RecoverypassOk'

export default function App() {
    const isLoggedNotIn = isNotLoginLogin()

    return (
        <>
            <Router>
                <Routes>
                    <Route
                        path="/login"
                        element={
                            <LoginRoute>
                                <Login />
                            </LoginRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <PrivateRoute>
                                <Dashboard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/myaccount/:id"
                        element={
                            <PrivateRoute>
                                <FormMyAccount />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/users/new"
                        element={
                            <PrivateRoute>
                                <FormUsers />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/users/edit/:id"
                        element={
                            <PrivateRoute>
                                <FormUsers />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/users"
                        element={
                            <PrivateRoute>
                                <Users />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/company/new"
                        element={
                            <PrivateRoute>
                                <FormCompany />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/user/edit/:userc/timetable/user/:user/new/"
                        element={
                            <PrivateRoute>
                                <FormCompanyUserTimeTable />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/user/edit/:userc/timetable/user/:user/edit/:id"
                        element={
                            <PrivateRoute>
                                <FormCompanyUserTimeTable />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/user/edit/:userc/disableday/user/:user/new/"
                        element={
                            <PrivateRoute>
                                <FormCompanyUserDisabledays />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/user/edit/:userc/disableday/user/:user/edit/:id"
                        element={
                            <PrivateRoute>
                                <FormCompanyUserDisabledays />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/company/edit/:id"
                        element={
                            <PrivateRoute>
                                <FormCompany />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/timetable/new"
                        element={
                            <PrivateRoute>
                                <FormTimeTable />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/timetable/edit/:id"
                        element={
                            <PrivateRoute>
                                <FormTimeTable />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/timetable"
                        element={
                            <PrivateRoute>
                                <Timetable />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/disabledays/new"
                        element={
                            <PrivateRoute>
                                <FormDisabledays />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/disabledays/edit/:id"
                        element={
                            <PrivateRoute>
                                <FormDisabledays />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/disabledays"
                        element={
                            <PrivateRoute>
                                <Disabledays />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/share"
                        element={
                            <PrivateRoute>
                                <Share />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/rent/new"
                        element={
                            <PrivateRoute>
                                <FormRent />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/rent"
                        element={
                            <PrivateRoute>
                                <Rent />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/bill"
                        element={
                            <PrivateRoute>
                                <Bill />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/changepass"
                        element={
                            <PrivateRoute>
                                <FormChangePass />
                            </PrivateRoute>
                        }
                    />
                    <Route path="/recoverypass" element={<Recoverypass />} />
                    <Route
                        path="/recoverypassok"
                        element={<RecoverypassOk />}
                    />
                    {isLoggedNotIn ? (
                        <Route path="/" element={<Login />} />
                    ) : (
                        <Route
                            path="/"
                            element={
                                <PrivateRoute>
                                    <Dashboard />
                                </PrivateRoute>
                            }
                        />
                    )}
                </Routes>
            </Router>
        </>
    )
}
